import React from "react";

const PauseIcon = (props: any) => {
  return (
    <svg width={30} height={30} fill="none" {...props}>
      <path
        fill="var(--color-icon-obscure)"
        stroke="var(--color-icon-obscure)"
        d="M26.963 15c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12Z"
        opacity={0.4}
      />
      <path
        fill="var(--color-icon-obscure)"
        stroke="var(--color-icon-obscure)"
        d="M12.9 11.213v7.575a.806.806 0 0 1-.026.233.164.164 0 0 1-.016.037.035.035 0 0 1-.006.008c-.002.003-.067.059-.352.059h-1.613c-.276 0-.337-.056-.339-.057l-.006-.009a.168.168 0 0 1-.016-.037.81.81 0 0 1-.026-.234v-7.575a.81.81 0 0 1 .026-.235.168.168 0 0 1 .016-.037l.006-.009c.002-.001.063-.057.34-.057h1.624c.277 0 .338.056.34.057l.006.009c.004.005.01.017.016.037a.81.81 0 0 1 .026.235Z"
      />
      <path
        fill="var(--color-icon-obscure)"
        d="M20 18.788v-7.575c0-.6-.25-.838-.888-.838H17.5c-.638 0-.888.238-.888.838v7.575c0 .6.25.837.888.837h1.612c.638 0 .888-.238.888-.837Z"
      />
    </svg>
  );
};

export default PauseIcon;
